// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { logout as AuthLogOut } from '@ideapa/app-auth';
import { concatReducers } from '@ideapa/app-common';
import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { KeyValue, onNgrxForms } from 'ngrx-forms';
import { LazyEntityActions, LazyEntityState } from './models';

export function createReducerFactory<T, K extends KeyValue>(
  entityName: string
) {
  function extendBaseReducer<V extends LazyEntityState<T, K>>(
    initialState: V,
    actions: LazyEntityActions<T, K>,
    reducerExtension: ActionReducer<V, Action>
  ) {
    const basicReducer = createReducer<V>(
      initialState,
      on(actions.setPageSize, (s, { pageSize }) => ({
        ...s,
        gridState: { ...s.gridState, pageSize },
      })),
      on(actions.setTotalRows, (s, { totalRows }) => ({
        ...s,
        gridState: { ...s.gridState, totalRows },
      })),
      on(actions.setCurrentPage, (s, { currentPage }) => ({
        ...s,
        gridState: { ...s.gridState, currentPage },
      })),
      on(actions.setPageLoaded, (s, { loaded }) => ({
        ...s,
        gridState: { ...s.gridState, pageLoaded: loaded },
      })),
      on(actions.setColumnState, (s, { columnState }) => ({
        ...s,
        gridState: { ...s.gridState, columnState },
      })),
      on(actions.setFilterModel, (s, { filterModel }) => ({
        ...s,
        gridState: { ...s.gridState, filterModel },
      })),
      on(actions.selectEntityId, (state, { id }) => {
        return { ...state, selectedId: id };
      }),
      on(actions.updateSuccess, (s, { item }) => ({
        ...s,
        loadedEntity: item,
      })),
      on(actions.showAdvancedFilters, (s, { show }) => {
        return { ...s, showAdvancedFilters: show };
      }),
      on(actions.loadSingleSuccess, (s, { item }) => ({
        ...s,
        loadedEntity: item,
      })),
      on(actions.resetState, (s, { entity }) => {
        if (entity === entityName) {
          return { ...(initialState as any) };
        } else return s;
      }),
      on(AuthLogOut, (s) => ({ ...(initialState as any) })),
      onNgrxForms()
    );

    return concatReducers(basicReducer, reducerExtension);
  }

  return {
    extendBaseReducer,
  };
}
